module.exports = __webpack_public_path__ + "static/img/stripe-logo.c933499.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/stripe-logo.png
// module id = 6T5s
// module chunks = 0